import { observer, useObserver } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import "./index.css";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { CommonStore } from "../../store";
import { Breadcrumb, Form, Layout, Menu, MenuProps, theme } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

const { Header, Sider, Content } = Layout;

function Commonview() {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  let initSelect: string = "";
  //
  const [openKeys, setOpenKeys] = useState([initSelect]);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const menuClick: MenuProps["onClick"] = (e) => {
    CommonStore.findKey(CommonStore.newMenuRouter, e.key);
    navigate(e.key);
  };
  const handleOpen = (keys: string[]) => {
    setOpenKeys(keys);
  };

  //前往个人中心
  const personalPage = () => {
    try {
      CommonStore.personal();
      navigate("/personal");
    } catch (error) {
      console.log(error);
    }
  };
  // 获取当前导航选中项的路径
  const useLocaltionPath = useLocation().pathname;
  useEffect(() => {
    const fn = async () => {
      await CommonStore.loginUserInfo();
      await CommonStore.getMenuList();
      // if(CommonStore.menuList.length <= 0) {
      //   navigate("/login");
      // }
      CommonStore.findKey(CommonStore.newMenuRouter, useLocaltionPath);
      CommonStore.changeBreadcrumb(
        CommonStore.newMenuRouter,
        location.pathname
      );
    };
    fn();
    const refreshThePage = () => {
      let rank = useLocaltionPath.split("/");
      if (rank.length >= 3) {
        rank.pop(); //移除最后一个元素
        let newOpenKeys: string[] = [];
        for (let i = rank.length; i > 1; i--) {
          newOpenKeys.push(rank.slice(0, i).join("/"));
          setOpenKeys(newOpenKeys);
        }
      }
    };
    refreshThePage();
  }, [location.pathname]);

  return (
    <Fragment>
      <Layout style={{ minHeight: "100vh" }}>
        <Sider
          style={{
            overflow: "auto",
            height: "calc(100vh - 48px)",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            zIndex:99
          }}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div className="demo-logo-vertical" />
          <div className="title" >翼小号企业门户</div>
          <Menu
            theme="dark"
            mode="inline"
            style={{marginTop:'50px'}}
            items={CommonStore.newMenuRouter}
            onClick={menuClick}
            onOpenChange={handleOpen}
            openKeys={openKeys}
            selectedKeys={[useLocaltionPath]}
          />
        </Sider>
        <Layout style={{ marginLeft: collapsed ? 80 : 200 }}>
          <Header style={{ padding: 0, background: colorBgContainer,position:'fixed',zIndex:'9',width:`calc(100% - ${collapsed ? '80px' : '200px'})` }}>
            <Breadcrumb
              className="breadHead"
              items={CommonStore.breadcrumbTitle}
            />
            <div className="personal">
              <UserOutlined className="top-icon" />
              <span className="topRight">{CommonStore.userInfo.accountDisplayName}</span>
              <LogoutOutlined
                className="top-icon"
                onClick={CommonStore.toLogOut}
              />
              <span
                className="topRight"
                style={{ cursor: "pointer" }}
                onClick={CommonStore.toLogOut}
              >
                退出
              </span>
            </div>
          </Header>
          <Content className="site-layout-background" style={{ overflow: "initial",margin: 12,marginTop:62,padding:'0 12px' }}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Fragment>
  );
}

export default observer(Commonview);
